import * as SrvgCore from "@gaming/srvg-classes-core";
import * as Vbl from './VblModule';
import { App } from "./vbl/App/App";
import initGlobalFunctions from './globalFunctions/globalFunctions';
import initExternals from './initExternals';

const Browser = SrvgCore.Browser;
const DebugView = SrvgCore.DebugView;

$( function() {
    'use strict';
    (function ($, srvg) {
        initExternals();
        // Globally set jquery animation tick to 50ms instead of the default 13ms for smoother jquery animations
        jQuery.fx.interval = 50;
        (window as any).Srvg = SrvgCore;
        (window as any).Vbl = Vbl;
        (window as any).Widgets = SrvgCore;
        srvg.config = srvg.config || {};
        srvg.screenName = "web";   // do not change, because of setVblMatchday

        if(Browser.getUsedBrowser() === 'IE11'){
            srvg.widgets['statistics-ranking'].enabled = false;
        }

        app = new App( {
            inactivityController: true,
            customerIntegration: true
        } );
        initGlobalFunctions(app);
        app.view = new Vbl.WebView({});
        app.viewController = new Vbl.WebViewController( { webView: app.view } );

        srvg.debugView = new DebugView( { selector: '#debugView' } );

        srvg.product.revision = 'VBL $Rev$';

    }($, srvg));
});